// Copyright (c) 2016 Deere & Company

import actions from '../../action-list';
import {getDefaultState as getClaimDefaultState} from '../state';

const setIsSubmitDisabled = (state, action) => action.isDisabled;

export default (state = getClaimDefaultState().isSubmitDisabled, action) => {

    const actionTypes = {
        [actions.UPDATE_LABOR_RATE_IS_SUBMIT_DISABLED]: setIsSubmitDisabled
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/claim/labor-rate-change/reducers/is-submit-disabled.js